import { render, staticRenderFns } from "./FullWidthSlider.vue?vue&type=template&id=52a22dc1&scoped=true&"
import script from "./FullWidthSlider.vue?vue&type=script&lang=js&"
export * from "./FullWidthSlider.vue?vue&type=script&lang=js&"
import style0 from "./FullWidthSlider.vue?vue&type=style&index=0&id=52a22dc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a22dc1",
  null
  
)

export default component.exports